import React, {Component} from 'react';
import {Route, Switch, withRouter, Redirect} from 'react-router-dom';
import { connect } from 'react-redux';
import Pusher from 'pusher-js';
import { updateObject } from '../../global/utility';

import * as billboardActions from '../actions/index';
import * as userActions from '../../global/user/actions/index';

import LoadingIndicator from '../../global/loading_indicator/loading_indicator';
import Button from '../../global/button/button';
import TextField from '../../global/text_field/text_field';
import MediaGridView from '../../global/grid_view/media_grid_view';
import Modal from '../../global/modal/modal';
import BillboardPlaylistMediaAttachmentView from './billboard_playlist_media_attachment_view';
import { PaperClipIcon, ArrowDownTrayIcon, ArrowUpTrayIcon, TrashIcon, PlayIcon, EllipsisVerticalIcon } from '@heroicons/react/24/outline';
import PlaylistSlideshow from '../playlist_slideshow/playlist_slideshow';
import PlaylistSeriesArtToolbar from '../playlist_series_art_toolbar/playlist_series_art_toolbar';
import logger from '../../global/logger';

class BillboardPlaylistEditView extends Component {

    state = {
        page_message: "",
        messages: [],
        playing: false,
        menuOpen: false,
    }

    _menuRef = React.createRef();

    componentDidMount() {
        this.props.onSelectPlaylistByID(this.props.match.params.id);
        logger.log(this.props.match.params.id);
        this.setState({});
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.props.onSelectPlaylistByID(this.props.match.params.id);
            // this.props.onFetchUserDetails(this.props.match.params.id);
            // this.props.onFetchCurrentUserPermissions();
            logger.log(this.props.match.params.id);
            // this.setState(updateObject(this.state, {selectedPlanId: null}));
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (e) => {
        if (this._menuRef.current && !this._menuRef.current.contains(e.target)) {
            this.setState({ menuOpen: false });
        }
    }

    toggleMenu = () => {
        this.setState(prev => ({ menuOpen: !prev.menuOpen }));
    }

    uploadMediaViaInput = () => {
        if (this._fileInput) this._fileInput.click();
    }


    changeHandler(event, property_name) {
        
        this.setState(updateObject(this.state, {page_message: event.target.value}));
        logger.log("message: " + this.state.page_message);
    }

    hasActiveItems() {
        const items = this.props.selected_playlist?.billboard_playlist_media_items || [];
        return items.some(item => item.billboard_media_item && item.billboard_media_item.active !== false);
    }

    exportPlaylist() {
        logger.log("exportPlaylist");
        this.props.onExportPlaylist(this.props.selected_playlist.id, () => {
            logger.log("exportPlaylist completed");
            this.props.onSelectPlaylistByID(this.props.match.params.id, () => {
                this.props.onFetchMedia();
            });
        });
    }

    deletePlaylist() {
        logger.log("deletePlaylist");
        let existing_index = this.props.playlists.findIndex(playlist => playlist.id === this.props.selected_playlist.id);
        this.props.onDeletePlaylist(this.props.selected_playlist.id, () => {
            
            if (this.props.playlists.length > existing_index) {
                this.props.onSelectPlaylist(this.props.playlists[existing_index])
            } else {
                this.props.onSelectPlaylist(this.props.playlists[this.props.playlists.length - 1])
            }
        });
    }


    didClickMedia(media) {
        logger.log("didClickMedia: " + media);
        Modal.dismissModal();
        this.props.onAttachMedia(this.props.selected_playlist.id, media.id, () => {
            this.props.onSelectPlaylistByID(this.props.match.params.id, () => {
                this.props.onFetchMedia();
            });
        });
        
    }

    attachMedia() {
        logger.log("attachMedia");
        Modal.insertModalElement(
            <BillboardPlaylistMediaAttachmentView media={this.props.media} didClickMedia={(media) => this.didClickMedia(media)} onClose={() => Modal.dismissModal()} />,
            true
        );
    }

    uploadMedia(file) {
        this.props.onUploadMedia(file, this.props.match.params.id, () => {
            this.props.onSelectPlaylistByID(this.props.match.params.id, () => {
                this.props.onFetchMedia();
            });
        });
    }

    onSave(item, callback) {
        logger.log("onSave: " + item);
        this.props.onSaveMedia(item, () => {
            this.props.onSelectPlaylistByID(this.props.match.params.id, () => {
                this.props.onFetchMedia(callback);
            });
        });
    }

    onDelete(item, callback) {
        logger.log("onDelete preparing to remove item: " + JSON.stringify(item));
        this.props.onDeleteMediaFromPlaylist(this.props.match.params.id, item.id, () => {
            logger.log("onDeleteMediaFromPlaylist: " + this.props.selected_playlist.id);
            this.props.onSelectPlaylistByID(this.props.match.params.id, () => {
                this.props.onFetchMedia(callback);
            });
        });
    }

    // #482 — first-preview tile for the per-playlist series art.
    // The server resolves the effective URL (`effective_per_playlist_series_art_url`);
    // this renders it as a distinct tile above the media grid, per the
    // ticket spec: "If artwork is attached, display it as the first
    // preview in the playlist."
    renderSeriesArtPreview() {
        const playlist = this.props.selected_playlist;
        // The Ruby method is `per_playlist_series_art_active?` — Rails'
        // as_json preserves the `?`, so the JSON key literally ends with
        // one. Fall back to the raw enabled+source pair when the projected
        // field isn't returned yet (older cached bundle before the ship).
        const active = playlist && (
            playlist['per_playlist_series_art_active?'] ||
            playlist.per_playlist_series_art_active
        );
        if (!playlist || !active) return null;
        const url = playlist.effective_per_playlist_series_art_url;
        if (!url) return null;
        const title = playlist.effective_per_playlist_series_art_title || 'Series Art';
        return (
            <div
                id="playlist_series_art_first_preview"
                className="mt-4 mb-2 rounded-lg border border-blue-200 bg-blue-50 p-3 flex items-start gap-3"
            >
                <div className="rounded-md overflow-hidden bg-gray-100" style={{ width: '160px', aspectRatio: '16/9' }}>
                    <img src={url} alt={title} className="w-full h-full object-contain" />
                </div>
                <div className="min-w-0 flex-1">
                    <div className="text-xs uppercase tracking-wide text-blue-600 font-semibold mb-1">
                        Series art (first slide)
                    </div>
                    <div className="text-sm text-gray-800 truncate" title={title}>{title}</div>
                    <div className="text-xs text-gray-500">
                        Injected as the first slide on paired devices.
                    </div>
                </div>
            </div>
        );
    }

    render () {
        
        const { path } = this.props.match;

        if (this.props.selected_playlist == null) {
            return <div><p>Loading...</p></div>
        }

        let exporting_indicator = null;
        if (this.props.exporting_playlist) {
            exporting_indicator = (
                <div className="flex mt-4 p-4 bg-gray-100 rounded-md border border-gray-200">
                    <LoadingIndicator className="w-5 h-5 mr-2 float-left" />
                    <p className="float-left ml-2 text-gray-900">Exporting playlist...</p>
                </div>
            )
        }

        let content = (
            <div>
                <TextField label="Playlist Title" property_name="playlist_title" value={this.props.selected_playlist.title} changeHandler={(event) => this.changeHandler(event, "playlist_title")} placeholder="Enter a playlist title" />
                
                <div className="flex items-center gap-2 mb-2">
                    <Button id="play_button" text="Play" icon={PlayIcon} clickEvent={() => this.setState({ playing: true })} disabled={!this.hasActiveItems()} />
                    <Button id="download_button" text="Download" icon={ArrowDownTrayIcon} clickEvent={() => this.exportPlaylist()} disabled={!this.hasActiveItems()} />

                    <div className="relative" ref={this._menuRef}>
                        <a onClick={this.toggleMenu} className="inline-flex items-center rounded-sm shadow-xs bg-blue-500 px-3 py-3 text-white cursor-pointer hover:bg-blue-400">
                            <EllipsisVerticalIcon className="h-5 w-5" />
                        </a>
                        {this.state.menuOpen && (
                            <div className="absolute right-0 mt-1 w-48 bg-white rounded-sm shadow-lg border border-gray-200 z-50">
                                <button
                                    className="w-full flex items-center gap-2 px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 text-left"
                                    onClick={() => { this.setState({ menuOpen: false }); this.uploadMediaViaInput(); }}
                                >
                                    <ArrowUpTrayIcon className="h-4 w-4" /> Upload Media
                                </button>
                                <button
                                    className="w-full flex items-center gap-2 px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 text-left"
                                    onClick={() => { this.setState({ menuOpen: false }); this.attachMedia(); }}
                                >
                                    <PaperClipIcon className="h-4 w-4" /> Attach Media
                                </button>
                                <hr className="border-gray-200" />
                                <button
                                    className="w-full flex items-center gap-2 px-4 py-3 text-sm text-red-600 hover:bg-red-50 text-left"
                                    onClick={() => { this.setState({ menuOpen: false }); this.deletePlaylist(); }}
                                >
                                    <TrashIcon className="h-4 w-4" /> Delete Playlist
                                </button>
                            </div>
                        )}
                    </div>

                    <input
                        ref={(el) => { this._fileInput = el; }}
                        type="file"
                        accept="image/*"
                        multiple
                        className="hidden"
                        onChange={(e) => {
                            for (let i = 0; i < e.target.files.length; i++) {
                                this.uploadMedia(e.target.files[i]);
                            }
                            e.target.value = null;
                        }}
                    />
                </div>

                {exporting_indicator}

                <PlaylistSeriesArtToolbar playlist={this.props.selected_playlist} />

                {this.renderSeriesArtPreview()}

                <MediaGridView className="mt-4" onSave={(item, callback) => this.onSave(item, callback)} onDelete={(item, callback) => this.onDelete(item, callback)} playlist_id={this.props.selected_playlist.id} items={this.props.selected_playlist.billboard_playlist_media_items ? this.props.selected_playlist.billboard_playlist_media_items : []} />
            </div>
        );

        if (this.props.loading_playlists) {
            content = (
                <LoadingIndicator />
            )
        }

        const activeItems = (this.props.selected_playlist?.billboard_playlist_media_items || [])
            .filter(item => item.billboard_media_item && item.billboard_media_item.active !== false);

        return (
            <>
                {content}
                {this.state.playing && activeItems.length > 0 && (
                    <PlaylistSlideshow
                        items={activeItems}
                        secondsPerSlide={this.props.selected_playlist?.effective_seconds_per_slide ?? this.props.selected_playlist?.seconds_per_slide}
                        onClose={() => this.setState({ playing: false })}
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        loading_playlists: state.billboard.loading_playlists,
        playlists: state.billboard.playlists,
        selected_playlist: state.billboard.selected_playlist,
        deleting_playlist: state.billboard.deleting_playlist,
        exporting_playlist: state.billboard.exporting_playlist,
        saving_media: state.billboard.saving_media,
        deleting_media: state.billboard.deleting_media,
        media: state.billboard.media,
        loading_media: state.billboard.loading_media,
        deleting_media_from_playlist: state.billboard.deleting_media_from_playlist
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onSelectPlaylist: (playlist) => dispatch(billboardActions.selectPlaylist(playlist)),
        onFetchPlaylists: (callback) => dispatch(billboardActions.fetchPlaylists(callback)),
        onUpdateAuthToken: (callback) => dispatch(userActions.updateAuthToken(callback)),
        onDeletePlaylist: (playlist_id, callback) => dispatch(billboardActions.deletePlaylist(playlist_id, callback)),
        onExportPlaylist: (playlist_id, callback) => dispatch(billboardActions.exportPlaylist(playlist_id, callback)),
        onSelectPlaylistByID: (playlist_id, callback) => dispatch(billboardActions.selectPlaylistByID(playlist_id, callback)),
        onUploadMedia: (media_file, playlist_id, callback) => dispatch(billboardActions.uploadMedia(media_file, playlist_id, callback)),
        onFetchMedia: (callback) => dispatch(billboardActions.fetchMedia(callback)),
        onSaveMedia: (media, callback) => dispatch(billboardActions.saveMedia(media, callback)),
        onDeleteMedia: (media_id, callback) => dispatch(billboardActions.deleteMedia(media_id, callback)),
        onDeleteMediaFromPlaylist: (playlist_id, item_id, callback) => dispatch(billboardActions.deleteMediaFromPlaylist(playlist_id, item_id, callback)),
        onAttachMedia: (playlist_id, media_id, callback) => dispatch(billboardActions.attachMedia(playlist_id, media_id, callback))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BillboardPlaylistEditView));